// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2yK2Q","inputWrap":"Table_inputWrap__3J0lQ","col":"Table_col__1jUNC","bmiTooltip":"Table_bmiTooltip__3vpqb"};